import { motion } from 'framer-motion';
import { FileText, GitBranch, ListChecks, Book, Square } from 'lucide-react';
import { cn } from '@/lib/utils';

const tabs = [
  { id: 'notes', label: 'Smart Notes', icon: FileText },
  { id: 'mindmap', label: 'Mind Map', icon: GitBranch },
  { id: 'quiz', label: 'MCQ Quiz', icon: ListChecks },
  { id: 'glossary', label: 'Glossary', icon: Book },
  { id: 'flashcards', label: 'Flashcards', icon: Square },
];

interface OutputControlsProps {
  activeTab: string;
  onTabChange: (id: string) => void;
}

export function OutputControls({ activeTab, onTabChange }: OutputControlsProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center gap-4 rounded-lg bg-white p-2 shadow-sm"
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex flex-1 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors',
              {
                'bg-indigo-50 text-indigo-600': activeTab === tab.id,
                'text-gray-600 hover:bg-gray-50': activeTab !== tab.id,
              }
            )}
          >
            <Icon className="h-4 w-4" />
            {tab.label}
          </button>
        );
      })}
    </motion.div>
  );
}